import { FunctionComponent, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { isEmpty } from 'lodash';
import ImportDocumentImagingDrawer from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportDocumentImagine';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { useSelector } from 'react-redux';
import { makeSelectNotification } from 'containers/AppContainer/selectors';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { filterDecidedImagineDocuments } from 'containers/CourtManagerLegalProceedings/ImagineDocuments/utils';
export interface ImportImagineDocumentButtonProps {
  intl: IntlShape;
  listings: any;
  managerNotifcationsInboxes: any;
  claimId?: number;
  imagineDocuments: any;
  claimSagisInfo: any;
  uploadDocument: Function;
  uploadedDocument: { response: string } | {};
  setUploadedDocs: Function;
  documentName: any;
  documentType: any;
  setDocumentId: Function;
  documentId: any;
  document?: any;
  requestGetDocByDocumentumId: Function;
}
const ImportImagineDocumentButton: FunctionComponent<ImportImagineDocumentButtonProps> = ({
  ...props
}): JSX.Element => {
  const [
    openDrawerImportationDocumentImagine,
    setOpenDrawerImportationDocumentImagine,
  ] = useState(false);
  const [displayButton, setDisplayButton] = useState(true);
  const imagineNotification = useSelector(makeSelectNotification());
  return (
    <>
      {!isEmpty(filterDecidedImagineDocuments(props.imagineDocuments)) &&
        displayButton &&
        featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
          <PrimaryButton
            onClick={() => setOpenDrawerImportationDocumentImagine(true)}
            disableElevation
            titlecolor="#ffffff"
            background="#0075c9"
            border="#0075c9"
            data-testId="validate-button"
            title={translate(messages.importDocumentTitleButton, props)}
            disabled={false}
          />
        )}
      <ImportDocumentImagingDrawer
        isDrawerOpen={openDrawerImportationDocumentImagine}
        setIsDrawerOpen={setOpenDrawerImportationDocumentImagine}
        listings={props.listings}
        managerNotifcationsInboxes={filterDecidedImagineDocuments(
          props.imagineDocuments,
        )}
        claimId={props.claimId}
        claimSagisInfo={props.claimSagisInfo}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        setUploadedDocs={props.setUploadedDocs}
        documentName={props.documentName}
        documentType={props.documentType}
        setDocumentId={props.setDocumentId}
        documentId={props.documentId}
        document={props.document}
        imagineNotification={imagineNotification}
        setDisplayButton={setDisplayButton}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
    </>
  );
};

export default injectIntl(ImportImagineDocumentButton);
